import { render, staticRenderFns } from "./ImageExtEditor.vue?vue&type=template&id=88b13dd8"
import script from "./ImageExtEditor.vue?vue&type=script&lang=js"
export * from "./ImageExtEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports